export default "/images/083d1e5183ed6b5c06015e37fc1fab8b.avif";